import {Link} from 'react-router';

const RfpCarrierLink = () => (
  <Link to="/rfp-carrier-bid-requests" activeClassName="active">
    RFPs
  </Link>
);

export default RfpCarrierLink;
